<template>
    <div>
        <div
            v-for="(line, key) in item.geometry.coordinates"
            :key="'line-' + key"
        >
            <l-marker
                :lat-lng="getCoordinates(line[0])"
                @click="openModal(line[0])"
            >
                <l-icon
                    :icon-url="marker"
                    :icon-size="iconSize"
                    :icon-anchor="[15.375, 37.5]"
                    ><img :src="marker" class="marker-icon"
                /></l-icon>
            </l-marker>
            <l-marker
                :lat-lng="getCoordinates(line[line.length - 1])"
                @click="openModal(line[line.length - 1])"
            >
                <l-icon
                    :icon-url="marker"
                    :icon-size="iconSize"
                    :icon-anchor="[15.375, 37.5]"
                    ><img :src="marker" class="marker-icon"
                /></l-icon>
            </l-marker>
            <l-polyline
                :lat-lngs="getCoordinates(line)"
                :color="style.color"
                :weight="style.weight"
            ></l-polyline>
        </div>
    </div>
</template>
<script>
import { LIcon, LPolyline, LMarker } from "vue2-leaflet";

export default {
    name: "MultiLineMarkerComponent",
    components: {
        LPolyline,
        LIcon,
        LMarker,
    },

    props: {
        item: {
            default: () => {},
        },
        iconSize: {
            default: () => [30.75, 37.5],
        },
    },

    mounted() {
        if (this.item.event_or_works_class === "_danger") {
            this.style.color = "#EF4035";
        } else {
            this.style.color = "#FFE033";
        }
    },

    data() {
        return {
            style: {
                color: "black",
                weight: 10,
            },
        };
    },

    computed: {
        marker() {
            if (this.item.event_or_works_class === "_danger") {
                return "/svg/map/markers/conditions/hac-danger.svg";
            } else {
                return "/svg/map/markers/conditions/hac-warning.svg";
            }
        },
    },

    methods: {
        getCoordinates(coordinates) {
            return coordinates;
        },

        openModal(coordinates) {
            this.$parent.$parent.$parent.$refs.map.mapObject.setView(
                coordinates,
                12
            );

            this.$store.commit("setData", {
                name: "selectedCondition",
                data: this.item,
            });
        },
    },
};
</script>
